import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { SocialExportGetConnectionStateDto } from '@mi-front/api-v2';
import { useIntl } from 'react-intl';
import { connectionIdentityMessages } from './connection-identity-messages';

type ConnectionIdentity = Pick<SocialExportGetConnectionStateDto, 'name' | 'profile'>;

/**
 * Resolves the label shown for a connection.
 * Custom `name` always wins; platforms without a user profile fall back to a generic default
 * instead of `profile.displayName`.
 */
export function useConnectionDisplayName(
  connection: ConnectionIdentity | null | undefined,
  platform: SocialPlatform,
): string | undefined {
  const { $t } = useIntl();

  if (!connection) {
    return undefined;
  }

  if (connection.name) {
    return connection.name;
  }

  if (!platform.hasUserProfile) {
    return $t(connectionIdentityMessages.defaultConnectionName);
  }

  return connection.profile.displayName;
}
